import parser from 'accept-language-parser';
import fetchJsonp from 'fetch-jsonp';
import Polyglot from 'node-polyglot';

import * as helpers from './helpers.js';
import * as i18nHelper from './i18n-helpers.js';
import * as state from './state.js';

let languages = [
  'en',
  'de',
  'it',
  'pt',
  'fr',
  'es',
  'ru',
  'ja',
  'zh',
  'zh-tw',
];

let isoLanguages = [
  'en',
  'de',
  'it',
  'pt',
  'fr',
  'es',
  'ru',
  'ja',
  'zh-TW',  // placed here bc of accept-language-parser behavior vs zh.
  'zh',
];


/*
Would you like to go to the English version?
¿Quieres ir a la versión en español?
Diese Seite auf Deutsch anzeigen?
Vuoi passare alla versione italiana?
Voulez-vous afficher le site en français ?
Gostaria de ir para a versão portuguesa?
日本語版にアクセスしますか？
Хотите перейти к версии на русском языке?
是否前往中文版页面？
是否前往繁體中文頁面？
*/

let lang = '';
let polyglot = {};
let inPlaceEditMode = false;

async function init() {
  if (location.search.substring(1).includes('i18n')) {
    inPlaceEditMode = true;
  }

  lang = getLanguageIso();  // we're running async with state.init(); can't use
                            // the state version
  await i18nHelper.loadLanguages(lang, polyglot, 'www');
  i18nHelper.translatePage(lang, polyglot, 'www', inPlaceEditMode);

  setupLanguagePicker();
}

function t(key, obj) {
  return polyglot.lang.t(key, obj);
}

// only the state should use this
function getLanguageIso() {
  let url = window.location.href;

  for (let i = 0; i < languages.length; i++) {
    let lang = languages[i];

    // saleae.com/de or saleae.com/de/dentists
    if (url.endsWith('/' + lang) || url.includes('/' + lang + '/')) {
      // console.log(lang);
      return lang;
    }
  }

  // if this is the main property, then language is english
  if (url.includes('www.saleae')) return 'en';

  // if we're on a non saleae property, the language won't be in the above
  // format.

  // let's see if language is specified in the URL parameters
  const urlLang = helpers.getUrlParameter('lang');
  if (typeof urlLang !== 'undefined') {
    if (!languages.includes(urlLang))
      throw new Error(
          `Language ${urlLang} from url is not one of the languages supported`);

    // console.log(urlLang);
    return urlLang;
  }

  // let's see if language was previously saved in a cookie
  const cookieLang = state.getLanguageIsoFromCookie();
  if (cookieLang !== null) {
    if (!languages.includes(cookieLang))
      throw new Error(`Language ${
          cookieLang} from cookie is not one of the languages supported`);

    // console.log(cookieLang);
    return cookieLang;
  }

  return 'en';
}

// returns null if none of our languages loosely matches any of theirs
async function getBrowserLanguageIso() {
  // Note from Mark: On April 30 2021, we noiced a lot of errors when trying to load https://ajaxhttpheaders1.appspot.com.
  // This function is used, but it hasn't returned a value for at least 3 years, so the whole system was broken.
  // I think it's only used to check if we should load Baidu, and when it fails, we fall back to regular url detection.
  return null;
  /*
  let headersRaw = await fetchJsonp('https://ajaxhttpheaders1.appspot.com')
  let headers = await headersRaw.json();
  let acceptLanguages = headers['Accept-Language'];
  let bestLanguage = parser.pick(isoLanguages, acceptLanguages, {loose: true});
  */
  // console.log(`best language is ${bestLanguage}!`);
}

function setupLanguagePicker() {
  const lang = state.getLanguageIso();

  // note, on www, metalsmith i18n also sets the active language in the picker.

  let title = document.querySelector('.main-footer__bottom-language-title');
  if (!title)
    return;  // the page doesn't have our lang picker on it -- i.e. checkout

  let languageLinks =
      document.querySelectorAll('.main-footer__bottom-language-window-list a');
  languageLinks.forEach((element) => {
    let elementLang = element.getAttribute('data-lang');
    if (elementLang === lang) {
      element.classList.add('active');
      title.textContent = element.textContent;
    } else {
      element.classList.remove('active');
    };
  });

  let picker = document.querySelector('.main-footer__bottom-language');
  picker.addEventListener('click', () => {
    picker.classList.toggle('active');
  });

  editLangLinksToPointToCurrentPage();
}

function editLangLinksToPointToCurrentPage() {
  if (!helpers.isOnWww()) return;

  let links =
      document.querySelectorAll('.main-footer__bottom-language-window-list a');
  links.forEach((link) => {
    let lang = link.getAttribute('data-lang');
    let url = getLangLinkToCurrentWwwPage(lang);
    link.setAttribute('href', url);
  });
}

function getLangLinkToCurrentWwwPage(lang) {
  let url = window.location.href;

  // https://www.saleae.com
  // https://www.saleae.com/404.html
  // https://www.saleae.com/about
  // https://www.saleae.com/de/
  // https://www.saleae.com/de/404.html
  // https://www.saleae.com/de/about

  let www = helpers.getWwwRootUrl();
  // https://www.saleae.com

  url = i18nHelper.stripLanguageFromUrl(url);

  if (lang === 'en') return url;  // we're done

  let modifiedUrl = url.replace(www, `${www}/${lang}`);
  return modifiedUrl;
}

export {
  init,
  t,
  getLanguageIso,
  getBrowserLanguageIso,
};
